import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {FormSortType} from 'nutshell-graphql-types';
import type {
    GetWfFormsChat as GetWfFormsChatQuery,
    GetWfFormsChat_forms_edges_node as Form,
    GetWfFormsChat_forms_edges as FormEdges,
    GetWfFormsChatVariables as GetWfFormsChatQueryVariables,
} from 'nutshell-graphql-types';

import GET_WF_FORMS_CHAT from '../queries/get-wf-forms-chat.graphql';

export const useGetWfFormsChat = (input: {
    limit: number;
    after: string | null | undefined;
    archived: boolean;
    sort: FormSortType;
}) => {
    const {data, error, loading, refetch} = useQuery<
        GetWfFormsChatQuery,
        GetWfFormsChatQueryVariables
    >(GET_WF_FORMS_CHAT, {
        variables: {
            limit: input.limit,
            after: input.after,
            archived: input.archived,
            sort: input.sort,
        },
        fetchPolicy: 'cache-and-network',
    });

    const forms: Array<Form> | null | undefined = data
        ? data.forms.edges.map<Form>((edge: FormEdges) => edge.node)
        : null;

    return {
        forms,
        isLoading: loading && !forms,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetchWfForms: refetch,
    };
};
